import SectionWithItems from "../../scripts/SectionWithItems";
import deadlocket from "../../data/deadlocket";

const projects = [
    deadlocket,
    {
        "left": "Sea of Marbles",
        "right": "",
        "image": "/images/bandletech/sea-of-marbles-1.jpg",
        "parallax1": -200,
        "parallax2": 200,
        "link": "/projects/sea-of-marbles"
    },
    {
        "left": "Infinity Brick Breaker",
        "right": "",
        "image": "/images/bandletech/infinity-brick-breaker-1.jpg",
        "parallax1": -200,
        "parallax2": 200,
        "link": "/projects/infinity-brick-breaker"
    },
    {
        left: "Infinity Sort! Color Puzzle",
        right: "",
        image: "/images/bandletech/infinity-sort-1.webp",
        parallax1: -200,
        parallax2: 200,
        link: '/projects/infinity-sort'
    },
    {
        left: "Infinity Solitaire",
        right: "",
        image: "/images/bandletech/infinity-solitaire-2.webp",
        parallax1: -200,
        parallax2: 200,
        link: '/projects/infinity-solitaire'
    },
    {
        left: "Match Magic RPG",
        right: "",
        image: "/images/bandletech/match-magic-rpg-1.webp",
        parallax1: -200,
        parallax2: 200,
        link: '/projects/match-magic-rpg'
    },
    {
        left: "Unity Pokedex",
        right: "",
        image: "/images/pokemon screenshot 1.jpg",
        parallax1: -200,
        parallax2: 200,
        link: '/projects/unitydex'
    },
    {
        left: "Drift Universe",
        right: "",
        image: "/images/driftIcon.png",
        parallax1: -10,
        parallax2: 10,
        link: '/projects/driftuniverse'
    },
    {
        left: "Apocalyptic Survival",
        right: "",
        image: "/images/apocalypticsurvivalicon.png",
        parallax1: -200,
        parallax2: 200,
        link: '/projects/apocalypticsurvival',
    },
    {
        left: "Apocalypse Run",
        right: "",
        image: "/images/apocalypse6.jpg",
        parallax1: -200,
        parallax2: 200,
        link: '/projects/apocalypserun'
    },
    {
        left: "Flappy Duckz",
        right: "",
        image: "/images/flappy2.png",
        parallax1: -200,
        parallax2: 200,
        link: '/projects/flap'
    },
    {
        left: "Tic Tac Toe",
        right: "",
        image: "/images/tictactoe2.png",
        parallax1: -200,
        parallax2: 200,
        link: '/projects/tictactoe'
    },
];

const ProjectsPage = () => {
    return (
        <>
            <SectionWithItems title="All Projects" projects={projects}/>
        </>
    )
}

export default ProjectsPage;
